import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Form } from 'react-bootstrap';
import Select from 'react-select';

export const Yard = ({ handleChangeCaracObj, values, errors, touched }) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Individual' },
    { value: 2, label: 'Compartido' }
  ];

  return (
    <div>
      <Form.Group className="d-flex gap-2 align-items-center">
        <Form.Check
          type="checkbox"
          onChange={e => {
            handleChangeCaracObj('yard.active', e.target.checked);
            if (!e.target.checked) handleChangeCaracObj('yard.type', '');
          }}
          checked={values?.active || false}
        />
        <Form.Label className="m-0">Patio</Form.Label>
      </Form.Group>

      <Collapse in={values?.active}>
        <div className="mt-2">
          <Form.Group>
            <Form.Label>Tipo</Form.Label>
            <Select
              value={options.find(option => option.value === values?.type)}
              options={options}
              onChange={option =>
                handleChangeCaracObj(
                  'yard.type',
                  option?.value && Number(option.value)
                )
              }
              isSearchable={false}
            />

            {errors?.type && touched?.type && (
              <label className="w-100 text-danger">{errors.type}</label>
            )}
          </Form.Group>
        </div>
      </Collapse>
    </div>
  );
};

Yard.propTypes = {
  handleChangeCaracObj: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object
};
